import type { Dispatch } from "@reduxjs/toolkit"
import isEmpty from "~/lib/isEmpty"
import Storage, { STORAGE } from "~/lib/storage"
import LocalStorage from "~/lib/storage/LocalStorage"
import type { RootAppStore } from "~/store"
import type { CheckoutAction } from "~/store/checkout/actions"
import { CheckoutActions } from "~/store/checkout/constants"

export default (store: RootAppStore) =>
  (next: Dispatch) =>
  (action: CheckoutAction) => {
    if (action.type === CheckoutActions.AUTH_SUCCESS) {
      Storage.setSig(action.signature)
      LocalStorage.setBool(STORAGE.LOGIN_EXISTS, true)
      if (!isEmpty(action.login)) {
        LocalStorage.set(STORAGE.USER_LOGIN, action.login)
      }
      return next(action)
    }

    if (action.type === CheckoutActions.USER_REGISTER_SUCCESS) {
      LocalStorage.setBool(STORAGE.LOGIN_EXISTS, true)
      Storage.setSig(action.signature)

      return next(action)
    }

    if (action.type === CheckoutActions.EXTERNAL_AUTH_SUCCESS) {
      Storage.setSig(action.signature)
      Storage.clearSessionId()
      LocalStorage.setBool(STORAGE.LOGIN_EXISTS, true)
      if (!isEmpty(action.login)) {
        LocalStorage.set(STORAGE.USER_LOGIN, action.login)
      }
      Storage.setToken(action.newToken)

      store.dispatch({
        type: CheckoutActions.EXTERNAL_AUTH_DONE,
        redirectPath: action.redirectPath,
      })

      return next(action)
    }

    if (action.type === CheckoutActions.EXTERNAL_AUTH_DONE) {
      if (typeof window !== "undefined") {
        window.location.href = action.redirectPath
      }
    }

    return next(action)
  }
